import React, { useState, useEffect } from 'react';
import { Grid, Typography, Container, TextField, Pagination, Box, Skeleton, Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import BlogPostCard from '../components/blog/BlogPostCard';
import { getPosts } from '../services/api';
import { BlogPost } from '../types/BlogPost';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';

const BlogPosts = () => {
  const [searchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const limit = 6;
  const [pagination, setPagination] = useState<object | any>({})
  const [isLoading, setIsLoading] = useState(false);
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const categoryFilter = searchParams.get('categoryId');

  const fetchPosts = async (category='', searchTerm='', paging = 1, limit = 6) => {
    try {
      setIsLoading(true)
      const { data }: any = await getPosts(category, searchTerm, paging, limit);
      const formattedPost = (data?.posts as any[]).map(({ _id, ...rest }) => ({
        id: _id,
        ...rest
      }));
      setPagination(data.pagination);
      setPosts(formattedPost as any)
    } catch (error) {
      enqueueSnackbar((error as any).message, { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchPosts(categoryFilter || '', searchTerm || '', page, limit);
  }, [categoryFilter, searchTerm, page, limit]);

  // useEffect(() => {
  //   if (categoryFilter && searchTerm) {
  //     fetchPosts(categoryFilter, searchTerm as any);
  //   } else if (categoryFilter) {
  //     fetchPosts(categoryFilter as any);
  //   } else if (searchTerm) {
  //     fetchPosts('', searchTerm as any);
  //   } else {
  //     fetchPosts();
  //   }
  // }, [categoryFilter, searchTerm]);

  // Reset page when search term or category changes
  useEffect(() => {
    setPage(1);
  }, [searchTerm, searchParams]);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };
  function getCategoryNameById(categoryId: string): string | null {
    const post = posts.find(post => post.categoryId._id === categoryId);
    return post ? post.categoryId.name : null;
  }
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom sx={{ my: 4 }}>
        {categoryFilter ? `${getCategoryNameById(categoryFilter)} Posts` : 'All Blog Posts'}
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search posts..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 4 }}
      />
      {isLoading ? (
        <Grid container spacing={4}>
          {[...Array(6)].map((_, index) => (
            // @ts-ignore - Ignoring the item prop type issue
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Stack spacing={1}>
                <Skeleton variant="rectangular" width="300px" height={200} />
                <Skeleton variant="text" width="80%" height={24} />
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="text" width="90%" height={16} />
                <Skeleton variant="text" width="70%" height={16} />
              </Stack>
            </Grid>
          ))}
        </Grid>
      ) : posts.length === 0 ? (
        <Typography variant="h6" align="center" sx={{ my: 4 }}>
          No posts found matching your criteria.
        </Typography>
      ) : (
        <>
          <Grid container spacing={4}>
            {posts.map((post) => (
              // @ts-ignore - Ignoring the item prop type issue
              <Grid item key={post.id} xs={12} sm={6} md={4}>
                <BlogPostCard post={post} />
              </Grid>
            ))}
          </Grid>
          {pagination?.total > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <Pagination
                count={pagination?.pages}
                page={pagination?.page}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          )}
        </>
      )}
      <SnackbarProvider/>
    </Container>
  );
};

export default BlogPosts; 